import { SVGProps } from 'react';

/**
 * Inlined eBay shopping-bag icon. Replaces the 47KB `ebay-bag.png` asset
 * that caused a late-frame pop-in inside ActionMenu rows. Paints with
 * the bundle, no network round-trip.
 */
export function EbayBag(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			viewBox="0 0 64 64"
			xmlns="http://www.w3.org/2000/svg"
			aria-label="eBay"
			role="img"
			{...props}
		>
			{/* Handle */}
			<path
				d="M18 26 V20 a14 14 0 0 1 28 0 V26"
				fill="none"
				stroke="#3a3a3a"
				strokeWidth="4"
				strokeLinecap="round"
			/>
			{/* Bag bands with rounded bottom corners */}
			<path d="M4 26 H17 V60 H8 a4 4 0 0 1 -4 -4 Z" fill="#e53238" />
			<rect x="17" y="26" width="13" height="34" fill="#0064d2" />
			<rect x="30" y="26" width="13" height="34" fill="#f5af02" />
			<path d="M43 26 H60 V56 a4 4 0 0 1 -4 4 H43 Z" fill="#86b817" />
		</svg>
	);
}
